import Styles from './BasicDetails.module.scss';
import { useState } from 'react';

// component imports
import { Card, Form, Message } from 'components/lib';

// module imports
import TextField from '@mui/material/TextField';
import Slide from '@mui/material/Slide';
import { FormControl, Autocomplete, FormHelperText } from '@mui/material';


export function BasicDetails({ profileData, handleInputChange, validation, props }) {

    const [uploadFinished, setUploadFinished] = useState(false);
    const containerName = process.env.REACT_APP_AZURE_BLOB_CONTAINER_NAME_HIRING;
    
    const states = [
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Andaman and Nicobar Islands",
        "Bihar",
        "Chandigarh",
        "Chhattisgarh",
        "Dadra and Nagar Haveli and Daman and Diu",
        "Delhi",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jammu and Kashmir",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Ladakh",
        "Lakshadweep",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Puducherry",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttarakhand",
        "Uttar Pradesh",
        "West Bengal",
    ];

    const handleChange = (event, values) => {
        handleInputChange(values, 'state');
    };

    return (
        <Slide direction="left" in mountOnEnter unmountOnExit>
            <span>
                <div id='nameForm' className={Styles.nameForm}>
                    <p id='subHeading'
                        className={`${Styles.subHeading}`}
                    >
                        Basic Details
                    </p>

                    <div
                        id='nameTextboxes'
                        className={Styles.nameTextboxes}
                    >
                        <TextField
                            error={!validation.first_name}
                            id="first-name"
                            label="First Name"
                            placeholder="John"
                            fullWidth={false}
                            helperText={!validation.first_name ? 'Enter a valid first name' : ' '}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                maxLength: 25
                            }}
                            value={profileData.first_name || ''}
                            onChange={(e) => handleInputChange(e.target.value, 'first_name')}
                        />
                        <TextField
                            error={!validation.last_name}
                            id="last-name"
                            label="Last Name"
                            placeholder="Doe"
                            fullWidth={false}
                            helperText={!validation.last_name ? 'Enter a valid last name' : ' '}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                maxLength: 25
                            }}
                            value={profileData.last_name || ''}
                            onChange={(e) => handleInputChange(e.target.value, 'last_name')}
                        />
                        <TextField
                            error={!validation.phone_number}
                            id="number"
                            label="Phone Number"
                            placeholder="10 Digit Number"
                            fullWidth
                            helperText={!validation.phone_number ? 'Enter a valid phone number' : ' '}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                maxLength: 11
                            }}
                            value={profileData.phone_number || ''}
                            onChange={(e) => handleInputChange(e.target.value, 'phone_number')}
                        />
                        <TextField
                            error={!validation.email}
                            id="email"
                            label="Email ID"
                            placeholder="youremail@domain"
                            fullWidth
                            helperText={!validation.email ? 'Enter a valid email address' : ' '}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                maxLength: 50
                            }}
                            value={profileData.email || ''}
                            onChange={(e) => handleInputChange(e.target.value, 'email')}
                        />
                        <div className={Styles.locationContainer}>
                            <FormControl sx={{ width: '50%'}} >
                                <Autocomplete
                                    id="state-select"
                                    fullWidth
                                    // disablePortal={true}
                                    autoHighlight
                                    options={states}
                                    value={profileData?.state ? profileData?.state : null}
                                    onChange={handleChange}
                                    renderInput={(params) => <TextField {...params} label="State" />}
                                    
                                />
                                <FormHelperText>
                                    Enter The State You Reside In Here
                                </FormHelperText>
                            </FormControl>

                            <TextField
                                error={!validation.location}
                                // fullWidth
                                id="location"
                                label="City"
                                placeholder="City"
                                helperText={!validation.location ? 'Enter a location' : ' '}
                                InputLabelProps={{
                                    shrink: true,
                                    maxLength: 500
                                }}
                                sx={{ width: '50%'}}
                                value={profileData.location || ''}
                                onChange={(e) => handleInputChange(e.target.value, 'location')}
                            />
                        </div>

                    </div>
                    <div id='pictureForm' className={Styles.pictureForm}>
                        <Card
                            restrictWidth
                            restrictHeight
                            noPadding
                            className={Styles.pictureCard}
                        >
                            {!uploadFinished ?
                                <span style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                    alignContent: "center",
                                    justifyContent: "center"
                                }}>
                                    {profileData?.profile_picture &&
                                        <div style={{ width: '75px', height: '75px', display: 'flex', alignItems: 'center', margin: '1em' }}>
                                            <img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}/${containerName}/profile_picture/${profileData?.profile_picture}`} alt="org_logo" />
                                        </div>
                                    }

                                    <Form
                                        buttonText={profileData?.createProfile ? 'Upload' : 'Update'}
                                        url='/api/hiring/profile_upload'
                                        method='POST'
                                        inputs={{
                                            profile_picture: {
                                                label: 'Your Picture That Will Appear On the Resume',
                                                type: 'file',
                                                max: 1,
                                                required: true,
                                                maxFileSize: 60,
                                                onlyImage: true,
                                                validUserName: true,
                                                disabled: true,
                                            }
                                        }}
                                        callback={(res) => {
                                            handleInputChange(res?.data?.data, 'profile_picture');
                                            setUploadFinished(true);
                                        }}
                                    />
                                </span>
                                :
                                <Message
                                    title='Profile Picture Saved'
                                    type='success'
                                    text='Your photo has been saved successfully.'
                                />}
                            <TextField
                                error={!validation.dob}
                                id="dob"
                                label="Date of Birth"
                                placeholder="DD-MM-YYYY"
                                fullWidth={false}
                                helperText={!validation.dob ? 'Enter a valid Date of Birth' : ' '}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                InputProps={{
                                    maxLength: 10
                                }}
                                value={profileData.dob || ''}
                                onChange={(e) => handleInputChange(e.target.value, 'dob')}
                            />
                        </Card>
                    </div>
                </div>
            </span>
        </Slide >
    )
}